import { FeedbackListDrawerActionMenu } from '@modules/feedback/components/FeedbackListDrawer/FeedbackListDrawerActionMenu';
import { Box, Stack, Typography } from '@mui/material';
import { ReactNode } from 'react';
import { QueryContainer } from 'v2/core/services/notebook/types';

interface FeedbackListDrawerHeaderProps {
  title: ReactNode;
  description: ReactNode;
  secondaryActionNode?: ReactNode;
  queryContainer: QueryContainer;
  feedbackCount?: number;
}

export const FeedbackListDrawerHeader = ({
  title,
  description,
  secondaryActionNode,
  queryContainer,
  feedbackCount,
}: FeedbackListDrawerHeaderProps) => {
  return (
    <Stack
      direction="row"
      alignItems="center"
      justifyContent="space-between"
      columnGap={2}
    >
      <Stack minWidth={0}>
        <Typography variant="h6">{title}</Typography>
        <Box>{description}</Box>
      </Stack>
      <Stack direction="row" columnGap={1}>
        {secondaryActionNode}
        <FeedbackListDrawerActionMenu
          queryContainer={queryContainer}
          feedbackCount={feedbackCount}
        />
      </Stack>
    </Stack>
  );
};
